module.exports = __webpack_public_path__ + "img/c8.005460f2.svg";